import { ElementKind } from './enums'
import { SectionData, WidgetData } from './types'

function getAllWidgetElements(sections: SectionData[]) {
  return sections.flatMap(sec => {
    return (
      sec.elements?.flatMap<WidgetData>(element =>
        element.kind === ElementKind.WIDGET ? (element as WidgetData) : [],
      ) || []
    )
  })
}

export default getAllWidgetElements
